<template>
    <input
        @change="onInputChangeHandler"
        @input="onInputChangeHandler"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
        :value="value"
        :disabled="disabled"
        :maxlength="maxlength"
        class="form-control"
        type="text"
    />
</template>

<script>
export default {
    name: 'input-number',

    props: {
        name: {
            type: String
        },

        disabled: {
            type: Boolean,
            default: false
        },

        min: {
            type: Number,
            default: 0
        },

        max: {
            type: Number,
            default: 10000
        },

        value: {
            type: Number
        }
    },

    data() {
        return {
            maxlength: this.max.toString().length
        }
    },

    methods: {
        onInputChangeHandler(e) {
            const regex = /[^0-9]+/g
            let val = e.target.value
            let empty = e.type === 'change' ? this.min : null
            e.target.value = val.replace(val.match(regex), '')

            if (parseFloat(e.target.value) > this.max) {
                e.target.value = this.max.toString()
            }

            if (parseFloat(e.target.value) <= 0) {
                e.target.value = this.min.toString()
            }

            this.$emit('input', isNaN(parseFloat(e.target.value)) ? empty : parseFloat(e.target.value))
        }
    }
}
</script>
